import React from 'react';
import PropTypes from 'prop-types';
import Translate from '@hydra/common/components/i18n';
import CriteriumIconAndText from '@hydra/common/criterium/CriteriumIconAndText';
import CriteriumTable from '@hydra/common/criterium/CriteriumTable';
import Icon from '@hydra/common/components/Icon';

const getRows = (tags) => {
  const createTableRow = ({ href, hreflang, isCorrect, source }) => {
    const icon = isCorrect
      ? <Icon type='woorank-success' color='success' size='xs' />
      : <Icon type='woorank-danger' color='error' size='xs' />;
    return [
      href,
      hreflang,
      source,
      icon
    ];
  };
  return tags.map(createTableRow);
};

export const CriteriumHreflang = ({ tags, isSelfReferencing }) => {
  const head = [
    <Translate content='hreflang_alternate_url' key='hreflang_alternate_url' />,
    <Translate content='hreflang_attribute' key='hreflang_attribute' />,
    <Translate content='hreflang_source' key='hreflang_source' />,
    ''
  ];

  return tags && tags.length > 0
    ? (
      <>
        <CriteriumIconAndText
          success={isSelfReferencing}
          text={<Translate content={isSelfReferencing ? 'hreflang_self_referencing_ok' : 'hreflang_self_referencing_ko'} />}
        />
        <CriteriumTable head={head} rows={getRows(tags)} fixedColumns={[5, 2, 2, 1]} striped nowrap />
      </>
      )
    : <Translate content='hreflang_ko' />;
};

CriteriumHreflang.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      hreflang: PropTypes.string.isRequired,
      isCorrect: PropTypes.bool.isRequired,
      source: PropTypes.string.isRequired
    })
  ),
  isSelfReferencing: PropTypes.bool.isRequired
};

export default CriteriumHreflang;
